<template>
    <v-app-bar id="core-app-bar" fixed app color="#ddd" flat height="88">
        <v-toolbar-title class="tertiary--text font-weight-light align-self-center">
            <v-btn icon @click="$store.commit('setDrawer', !$store.getters.drawer)">
                <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
        </v-toolbar-title>

        <v-spacer />

        <v-toolbar-items>
        <v-row align="center" class="mx-0" >

            <!-- <v-btn class="mr-6" @click="fast_login('lychee')">管理者登入</v-btn>
            <v-btn class="mr-6" @click="fast_login('ntu')">NTU登入</v-btn>
            <v-btn class="mr-6" @click="fast_login('ntu_doc1')">NTU_DOC1登入</v-btn>
            <v-btn class="mr-6" @click="fast_login('ntu_doc2')">NTU_DOC2登入</v-btn>
            <v-btn class="mr-6" @click="fast_login('kuas')">KUAS登入</v-btn>
            <v-btn class="mr-6" @click="fast_login('kuas_doc1')">KUAS_DOC1登入</v-btn>
            <v-btn class="mr-6" @click="refresh_token">更換TOKEN</v-btn> -->

            <span>{{ account_name }}</span>
            <v-menu offset-y>
                <template v-slot:activator="{on}">
                    <v-btn v-on="on" icon>
                        <v-icon >mdi-cog-outline</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <!-- <v-list-item to="/account_setting">
                        <v-list-item-title>帳號設置</v-list-item-title>
                    </v-list-item> -->
                    <v-list-item v-if="[1, 2].includes(account_type) && has_bot == 'true'">
                        <v-list-item-title @click="$router.push('/chat_bot')">ChatBot設定</v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title @click="logout()">登出</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            
        </v-row>
        </v-toolbar-items>
    </v-app-bar>
</template>

<script>
import bus from '../nav/bus'
var host_url = process.env.VUE_APP_HOST_URL

export default {
    data: () => ({
        items: [
            { title: '帳號設置' },
            { title: 'ChatBot設定' },
            { title: '登出' },
        ],
        account_type: parseInt(localStorage.getItem('account_type')),
        account_name: localStorage.getItem('account_name'),
        has_bot: localStorage.getItem('has_bot')
    }),

    watch: {
    },

    mounted () {
    },
    beforeDestroy () {
    },

    methods: {
        // 測試 refresh token
        refresh_token(){
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;

            xhr.addEventListener("readystatechange", () => {
                if (xhr.readyState === 4) {
                    var tmp = JSON.parse(xhr.responseText)
                    // console.log(tmp)
                    // var addnow = new Date();
                    // addnow.setHours(addnow.getHours()+Number(process.env.VUE_APP_EXPIRATION_DELTA_HOURS))
                    // document.cookie = "access_token="+String(tmp.token)+"; expires="+addnow.toUTCString();
                    // document.cookie = "expires="+addnow.toUTCString()+"; expires="+addnow.toUTCString();
                    // localStorage.setItem('lychee_user', tmp.lychee_user)
                }
            });

            xhr.addEventListener("error", ()=>{
                // this.$ga.event('main', 'axios_interceptors', 'Error')
            });
            xhr.open("POST", process.env.VUE_APP_HOST_URL+"token-refresh/");
            xhr.setRequestHeader("Content-Type", "application/json");
            // xhr.setRequestHeader("X-CSRFToken", getCookie('csrftoken'));
            xhr.send(null);
        },
        fast_login(username){
            var post_data = JSON.stringify({"username": username,
                                            "password": "test"})
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.addEventListener("readystatechange", () => {
               if (xhr.readyState === 4) {
                    var tmp = JSON.parse(xhr.responseText)
                    // console.log(tmp)
                    localStorage.setItem('account_type', tmp.account_type)
                }
            });
            xhr.addEventListener("error", ()=>{
            });
            xhr.open("POST", host_url+"api-token-auth/")
            xhr.setRequestHeader("Content-Type", "application/json");
            // xhr.setRequestHeader("X-CSRFToken", this.$cookies.get('csrftoken'));
            xhr.send(post_data);
        },

        logout(){
            // console.log('logout')
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.addEventListener("readystatechange", ()=>{
                if(xhr.readyState === 4){
                    document.cookie = "access_token=goodbye; expires=Thu, 18 Dec 2013 12:00:00 UTC";
                    document.cookie = "expires=goodbye; expires=Thu, 18 Dec 2013 12:00:00 UTC";

                    bus.$emit('alert', {msg: '成功登出~', title: "提示",　check: "我知道了"})

                    localStorage.removeItem('account_type')
                    localStorage.removeItem('vendor_id')
                    localStorage.removeItem('patientId')
                    localStorage.removeItem('patientNumber')
                    localStorage.removeItem('linePointData')
                    localStorage.removeItem('account_name')
                    localStorage.removeItem('has_bot')
                    localStorage.removeItem('has_link_bot')

                    this.$router.push('/login')
                }
            });
            xhr.addEventListener("error", ()=>{
                this.$ga.event('ToolBar', 'logout', 'Error')
            });
            xhr.open("POST", host_url+'logout/');
            xhr.setRequestHeader("Content-Type", "application/json");
            // xhr.setRequestHeader("X-CSRFToken", this.$cookies.get('csrftoken'));
            xhr.send(null);
        }

    }
}
</script>

<style>
  /* Fix coming in v2.0.8 */
  #core-app-bar {
    width: auto;
  }

  #core-app-bar a {
    text-decoration: none;
  }
</style>
